<template>
  <div v-if="hasChanges" class="resultRow">
    <i :class="resultClass" />
    <div>
      <strong>{{ title }}</strong>
      <div v-if="isSuccess">
        {{ resultMessage }}
      </div>
      <div v-else>{{ i18n.t('/change-order/results/error') }}</div>
    </div>
    <div class="errors">
      <div>
        <ul>
          <li v-for="errorMessage in errorMessages" :key="errorMessage">
            <strong> {{ errorMessage }} </strong>
          </li>
        </ul>
      </div>
      <slot />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    hasChanges: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    isTryOrderMode: {
      type: Boolean,
      required: false,
      default: null,
    },
    isSuccess: {
      type: Boolean,
      default: null,
    },
    errorMessages: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  computed: {
    resultClass() {
      if (this.isSuccess) {
        return 'successful-change fa fa-check-circle'
      }
      return 'unsuccessful-change fa fa-times-circle'
    },
    resultMessage() {
      if (this.isTryOrderMode) {
        return this.i18n.t('/change-order/results/try-order-success')
      } else {
        return this.i18n.t('/change-order/results/change-order-success')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.resultRow {
  margin-left: 30px;
  margin-bottom: 5px;
}

.errors {
  font-weight: bold;
  padding-left: 20px;
  padding-top: 10px;
}

.unsuccessful-change {
  position: relative;
  left: -25px;
  top: 30px;
  font-size: 16px;
  color: red;
}

.successful-change {
  position: relative;
  left: -25px;
  top: 30px;
  font-size: 16px;
  color: green;
}
</style>
